import styled from 'styled-components';

import {
    Card,
    IconChevronRightCircle,
    token,
    spaceMixin,
    Paragraph,
} from '@zillow/constellation';

import {
    Tag,
} from '@zillow/zrs-comet';

export const StyledCard = styled(Card)`
    height: 150px;
    cursor: pointer;
`;

export const StyledIconChevronRightCircle = styled(IconChevronRightCircle)`
    color: ${token('colors.brand')};
    float: right;
    position: relative;
    bottom: 3px;
    margin-left: ${spaceMixin('xs')};
`;

export const StyledSubTextContainer = styled.div`
    margin-bottom: ${spaceMixin('xs')};
`;

export const StyledTag = styled(Tag)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledParagraphForNameDisplay = styled(Paragraph)`
    text-transform: capitalize;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
